<template>
	<div role="main" class="cafe_ranking">
		<cafe-menu v-tiara="tiaraObj.mainCategory"
			:name="'카페 랭킹'"
			:has-buttons="true"
			:menu-list="mainCategories"
			:initial-index="initialIndex.main"
			:wrap-class="'feature_ranking'"
			@select="onMainCategorySelect"
			ref="rankingCategory"></cafe-menu>

		<div id="cMain">
			<div id="mArticle">
				<div class="sub_util">
					<div v-if="isTotalCategory" class="ask_cafe">
						<a v-tiara="tiaraObj.cafeRankInfo" target="_blank" href="//cs.daum.net/faq/36/6030.html#21597" class="link_ask">카페랭킹이란?</a>
					</div>
					<cafe-sub-menu v-else-if="subCategories.length" v-tiara="tiaraObj.subCategory"
						:menu-list="subCategories"
						:watch-menu="true"
						:initial-index="initialIndex.sub"
						@select="onSubCategorySelect"></cafe-sub-menu>

					<div class="ranking_opt">
						<dropdown v-if="isTotalCategory"
							:name="'level'"
							:options="levels"
							@select="onLevelSelect"></dropdown>
						<dropdown
							:name="'sortOption'"
							:options="sortOptions"
							@select="onSortOptionSelect"></dropdown>
					</div>
				</div>

				<ranking-section>
					<ranking-item v-for="(cafe, index) in firstRankingList" v-tiara="tiaraObj.rankingItem"
					              :key="'ranking-first-rank-' + index"
					              :rank="index" :cafe-info="cafe"></ranking-item>
				</ranking-section>

				<ranking-section>
					<ranking-item v-for="(cafe, index) in secondRankingList" v-tiara="tiaraObj.rankingItem"
					              :key="'ranking-second-rank-' + index"
					              :rank="index + sliceLength" :cafe-info="cafe"></ranking-item>
				</ranking-section>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import RankingSection from './components/ranking/RankingSection.vue';
import RankingItem from './components/ranking/RankingItem.vue';
import TodayCafePagination from './components/ranking/TodayCafePagination.vue';
import TodayCafe from './components/ranking/TodayCafe.vue';

export default {
	components: {
		RankingSection, RankingItem,
		TodayCafePagination, TodayCafe
	},

	data() {
		return {
			todayCafePage: 0,
			cafePerPage: 3,
			sliceLength: 10,
			sortOptions: ['카페점수', '회원'],
			initialIndex: {
				main: -1,
				sub: -1
			},
			categoryMap: {
				'life-economy': 'category_3',
				life: 'G',
				economy: 'J',
				society: 'K',
				fancafe: 'category_1',
				group: 'category_2',
				friendship: 'o',
				woman: 'H',
				'game-comics': 'category_5',
				comics: 'M',
				game: '6',
				'hobby-sport': 'category_4',
				hobby: '9',
				sport: '8',
				entertainment: 'category_7',
				movie: '2',
				music: '3',
				broadcast: 'L',
				art: '4',
				local: 'category_6',
				alumni: 'N',
				hometown: 'F',
				'e-village': 'Q',
				army: 'P',
				religion: 'E',
				education: 'category_8',
				learning: 'C',
				computer: '1',
				academic: 'D',
				university: 'A',
				school: 'B'
			},
			mainCategoryChangeComplete: true,
			ready: false
		}
	},
	computed: {
		...mapGetters({
			rankingList: 'getRanking',
			categories: 'getCategories',
			selectedCategory: 'getSelectedCategory',
			subCategories_: 'getSubCategories',
			levels: 'getLevels',
			todayCafe: 'getTodayCafe',
			tiaraObj: 'getTiaraObj'
		}),
		mainCategories() {
			return this.categories.map(v => v.name);
		},
		isTotalCategory() {
			return this.selectedCategory.main === '';
		},
		subCategories() {
			return this.subCategories_.map(v => v.name);
		},

		firstRankingList() {
			return this.rankingList.slice(0, this.sliceLength);
		},
		secondRankingList() {
			return this.rankingList.slice(this.sliceLength, this.rankingList.length);
		},

		todayCafeMaxPage() {
			return Math.ceil(this.todayCafe.length / this.cafePerPage);
		},
		todayCafeInPage() {
			return this.todayCafe.slice(
				this.todayCafePage * this.cafePerPage,
				(this.todayCafePage + 1) * this.cafePerPage
			);
		}
	},

	methods: {
		async onMainCategorySelect(index) {
			if (!this.ready) return;
			this.$store.commit('selectMainCategory', this.categories[index].id);
			this.mainCategoryChangeComplete = false;
			await this.$store.dispatch('loadRanking', { category: this.selectedCategory.main });
			this.mainCategoryChangeComplete = true;

			this.setHashByCategory();
		},
		async onSubCategorySelect(index) {
			if (!this.ready) return;
			this.$store.commit('selectSubCategory', this.subCategories_[index].id);
			if (this.selectedCategory.sub === '') {
				if (this.mainCategoryChangeComplete)
					await this.$store.dispatch('loadRanking', { category: this.selectedCategory.main });
			}
			else {
				await this.$store.dispatch('loadRanking', { category: this.selectedCategory.sub });
			}

			this.setHashByCategory();
		},
		onLevelSelect(selectedObj) {
			this.$store.commit('setSelectedLevel', selectedObj.selected);
			this.$store.dispatch('loadRanking');
			this.$trackEvent(this.tiaraObj.rankFilter);
		},
		onSortOptionSelect(selectedObj) {
			const isOrderedByScore = this.sortOptions[selectedObj.selected] === '카페점수';
			if (isOrderedByScore) {
				const category = this.selectedCategory.sub === '' ? this.selectedCategory.main : this.selectedCategory.sub;

				this.$store.commit('setSortOption', 'score');
				this.$store.dispatch('loadRanking', {
					category: category
				});
			} else {
				this.$store.commit('setSortOption', 'memberCnt');
			}
			this.$trackEvent(isOrderedByScore ? this.tiaraObj.scoreSort : this.tiaraObj.rankSort);
		},
		onPageChange(page) {
			this.todayCafePage = page;
		},

		parseHash(hash) {
			const categoryId = this.categoryMap[hash];
			let mainCategory, subCategory = '';

			if (['category_8', 'C', '1', 'D', 'A', 'B'].includes(categoryId)) // 학문/교육 카테고리
				this.$refs.rankingCategory.onShift();

			if (categoryId.indexOf('category_') < 0) {
				mainCategory = this.categories
					.filter(v => v.sub.map(w => w.id).indexOf(categoryId) !== -1)[0].id;
				subCategory = categoryId;
			} else {
				mainCategory = categoryId;
			}

			this.initialIndex.main = this.categories.findIndex(v => v.id === mainCategory);
			this.$store.commit('selectMainCategory', mainCategory);

			this.initialIndex.sub = this.subCategories_.findIndex(v => v.id === subCategory);
			this.$store.commit('selectSubCategory', subCategory);
		},

		setHashByCategory() {
			if (!this.ready) return;

			let hash = '';
			if (this.selectedCategory.main !== 'soaring' && this.selectedCategory.main !== '') {
				const entry = Object.entries(this.categoryMap).find(v => {
					if (this.selectedCategory.sub)
						return v[1] === this.selectedCategory.sub;
					return v[1] === this.selectedCategory.main;
				});
				if (entry) hash = entry[0];
			}
			location.replace(`#${hash}`);
		}
	},

	async created() {
		await this.$store.dispatch('loadCategories');
		await this.$store.dispatch('loadLevels');

		if (location.hash)
			this.parseHash(location.hash.slice(1, location.hash.length));

		this.ready = true;

		await this.$store.dispatch('loadRanking', {
			category: this.selectedCategory.sub ? this.selectedCategory.sub : this.selectedCategory.main
		});

		await this.$store.dispatch('loadTodayCafe');

		this.$trackPage();
	}
}
</script>
